import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { TeachAppAndLandingColorPalette as Color } from '@lalalilo/enums';
import { useState } from 'react';
import styled from 'styled-components';
import cookies from '../assets/cookies.svg';
import { Actions, BoxContent, BoxIllustration, BoxPresentation, BoxTitle, Button, } from './common';
import { Switch } from './Switch';
export const DetailedCookies = ({ onSave, localizedStrings, }) => {
    const [isPerformanceCookieSelected, setIsPerformanceCookieSelected] = useState(true);
    return (_jsxs(_Fragment, { children: [_jsxs(BoxContent, { children: [_jsx(BoxIllustration, { src: cookies }), _jsx(BoxTitle, { children: localizedStrings.functionalCookies }), _jsx(BoxPresentation, { children: localizedStrings.functionalCookiesDescription }), _jsxs(CookieToggle, { children: [_jsxs(CookieTitle, { children: [_jsx(Label, Object.assign({ id: "performance-cookies-label" }, { children: localizedStrings.performanceCookies })), _jsx(Switch, { ariaLabelledBy: "performance-cookies-label", ariaDescribedBy: "performance-cookies-description", onClick: () => setIsPerformanceCookieSelected(v => !v), on: isPerformanceCookieSelected, localizedStrings: localizedStrings.switchStrings })] }), _jsx(Text, Object.assign({ id: "performance-cookies-description" }, { children: localizedStrings.performanceCookiesDescription }))] })] }), _jsx(Actions, { children: _jsx(Button, Object.assign({ color: Color.purple_600, onClick: () => onSave(isPerformanceCookieSelected) }, { children: localizedStrings.save })) })] }));
};
const CookieToggle = styled.div `
  color: ${Color.grey_600};
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;
const CookieTitle = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 5px 0;
`;
const Label = styled.label `
  font-size: 14px;
  font-weight: 500;
  color: inherit;
`;
const Text = styled.p `
  font-size: 14px;
  color: inherit;
  margin: 0;
`;
//# sourceMappingURL=DetailedCookies.js.map